import React from "react";
import {
  withSitecoreContext,
} from "@sitecore-jss/sitecore-jss-react";

import "./index.scss";
import { LanguageDropdownModel } from "./models/LanguageDropdown.model";
import { LanguageDropdownProps } from "./types/LanguageDropdown.types";

const LanguageDropdown = (props: LanguageDropdownProps) => {
  const model = new LanguageDropdownModel(props);
  const getDropdownList = props?.fields?.Languages;
  const undifinedServer =
    typeof document !== "undefined" && typeof window !== "undefined";

  if (typeof window !== 'undefined' && typeof document!== 'undefined') {
    const langValue = localStorage.getItem('langValue');
    const select = document.querySelector(".privacy-language-dropdown #language-select-dropdown") as HTMLSelectElement;
    if (select && langValue) {
      select.value = langValue
    }
  }

  const redirectFromSelect = (elementValue) => {
    const selectedLangValue = elementValue;
    if (typeof window !== 'undefined') {
      localStorage.setItem('langValue', selectedLangValue);
      undifinedServer && (window.location = selectedLangValue);
    }
  };

  return (
    <>
      {props?.fields && (
        <div className="privacy-language-dropdown text-module--center">
          <select
            id="language-select-dropdown"
            className="language-select-dropdown"

            onChange={(element) => {
              redirectFromSelect(element.target.value);
            }}
          >
            {getDropdownList?.map((lang) => (
              <option
                className={lang.selected ? "lang_selected" : ""}
                value={lang?.url}
              >
                {lang?.label}
              </option>
            ))}
          </select>
        </div>
      )}
    </>

  );
};

export default withSitecoreContext()(LanguageDropdown);
